import { render, staticRenderFns } from "./sendEmailCode.vue?vue&type=template&id=fb5ec53c"
import script from "./sendEmailCode.vue?vue&type=script&lang=js"
export * from "./sendEmailCode.vue?vue&type=script&lang=js"
import style0 from "./sendEmailCode.vue?vue&type=style&index=0&id=fb5ec53c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb5ec53c')) {
      api.createRecord('fb5ec53c', component.options)
    } else {
      api.reload('fb5ec53c', component.options)
    }
    module.hot.accept("./sendEmailCode.vue?vue&type=template&id=fb5ec53c", function () {
      api.rerender('fb5ec53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/account/sendEmailCode.vue"
export default component.exports